







































import Vue from 'vue'

import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppDialog from '@/components/AppDialog.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import { Case } from '@/modules/Case/interfaces/case'
import { caseType, caseTypeClass } from '@/modules/Case/helpers/case'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { translateCaseTypeKey } from '@/utils/translate'

@Component({
  components: {
    AppDialog,
    AppBreadcrumbs,
    AppTableDate
  }
})
export default class CasesDialog extends Vue {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Array }) readonly cases!: Case[]

  caseTypeClass = caseTypeClass
  caseType = caseType
  translateCaseTypeKey = translateCaseTypeKey
  showDialog = false

  caseTableColumn = [
    { field: 'id',
      title: 'Case ID',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.id ? row.id : '-')
        ]
      }
      },
      sortable: true,
      resizable: true,
      width: 120,
      fixed: 'left'
    },
    { field: 'inquiryName',
      title: 'Case Name',
      slots: { default: 'name_default' },
      resizable: true,
      sortable: true
    },
    { title: 'Account Name',
      field: 'account',
      slots: { default: 'account_name_default' },
      resizable: true
    },
    { title: 'Contact Name',
      field: 'primaryContact',
      slots: { default: 'contact_name_default' },
      resizable: true
    },
    { title: 'Creation Time',
      field: 'createdAt',
      slots: {
        default: 'time_default'
      },
      resizable: true,
      sortable: true
    },
    {
      field: 'type',
      title: 'Type',
      slots: { default: 'type_default' },
      sortable: true,
      resizable: true
    },
    {
      title: 'Case Manager',
      field: 'caseManager',
      slots: {
        default: 'case_manager'
      },
      resizable: true,
      sortable: true
    }
  ]

  filteredCases: Case[] = []

  get casesPerPage () {
    const { tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const offset = (currentPage - 1) * pageSize
    return this.$R.slice(offset, pageSize + offset, this.filteredCases)
  }

  @Watch('show')
  async onShowChanged (val: boolean) {
    this.showDialog = val
  }

  @Watch('cases')
  onPoliciesChanged (val: Case[]) {
    this.tableOptions.loading = false
    this.tableOptions.tablePage.total = val.length
    this.tableOptions.tablePage.currentPage = 1
    this.filteredCases = val
  }

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.filterCases()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
  }

  @Emit('cancel')
  handleCancel () {
    // do nothing
  }

  filterCases () {
    const { filteredCases } = this
    const { sortBy, sortDesc } = this.tableOptions

    this.filteredCases = sortDesc
      ? this.$R.sortWith([this.$R.descend(this.$R.prop(sortBy))])(filteredCases)
      : this.$R.sortWith([this.$R.ascend(this.$R.prop(sortBy))])(filteredCases)
    this.tableOptions.tablePage.total = filteredCases.length
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    this.routeTo('CaseDetailDetail', {
      id: item.id
    })
  }

  routeToAccountDetail (item: any) {
    this.routeTo('AccountDetailDetail', {
      id: item.account.id
    })
  }

  routeToContactDetail (item: any) {
    this.routeTo('ContactDetailDetail', {
      id: item.primaryContact.id
    })
  }
}
